import { Col, Container, Row } from "react-bootstrap";
import ClientVulnerabilities from "../components/ClientVulnerabilities";
import useVulnerabilitySection from "../hooks/useVulnerabilitySection";
import Skeleton from "react-loading-skeleton";
import { FormLabel, FormTextArea, RichTextEditor } from "../../../components/forms";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { BooleanSelect } from "../../../components/forms/selects";
import { auto } from "@popperjs/core";
import toast from "react-hot-toast";
import useClientVulnerabilities from "../hooks/useClientVulnerabilities";

const VulnerabilitiesSection = () => {
    const { data, isLoading, isError, error, refetchVulnerabilitySection, createVulnerabilitySection, patchVulnerabilitySection, patchNotesSection } = useVulnerabilitySection();
    const { updateVulnerableAccountStatus } = useClientVulnerabilities();

    if (isError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={refetchVulnerabilitySection} />
        </ErrorMessageWrapper>;
    };

    const handleCreateSection = async () => {
        const createSection = await toast.promise(createVulnerabilitySection(), {
            loading: `Adding vulnerability section...`,
            success: () => {
                return `The vulnerability section has been added.`;
            },
            error: `Failed to add vulnerability section.`
        });
        if (createSection !== null) {
            toast.promise(updateVulnerableAccountStatus(true), {
                loading: `Adding vulnerable client status to master account...`,
                success: () => {
                    return `The master account is now vulnerable.`;
                },
                error: `Failed to set master account as vulnerable.`
            })
        }
    }

    return <Container fluid={true}>
        {isLoading
            ? <Skeleton height={30} count={2} />
            : data === null
            && <p className="mt-2 mb-0">There are no recorded client vulnerabilities. Click <button className="anchor" onClick={handleCreateSection}>here</button> to create one</p>}
        {data && <>
            <div className="row mt-2 mb-4">
                <ClientVulnerabilities
                    vulnerabilitySectionId={data?.vulnerabilitySectionId}
                    clientVulnerabilityIds={data?.clientVulnerabilityIds}
                />
            </div>
            <Row className="align-items-center mb-2 g-3">
                <Col sm={12} xl={auto} xxl={6}>
                    <FormLabel>
                        Have you discussed if the client would like a friend or family member to join meetings?
                    </FormLabel>
                </Col>
                <Col sm={2} xl={auto} xxl={1}>
                    {isLoading
                        ? <Skeleton width={100} />
                        : <BooleanSelect
                            defaultValue={data.accompaniedMeetingsDiscussed}
                            onBlur={({ value }) => patchVulnerabilitySection(data.vulnerabilitySectionId, "accompaniedMeetingsDiscussed", value)} />}
                </Col>
                <Col sm={10} xl={5} xxl={5}>
                    {isLoading
                        ? <Skeleton width={100} />
                        : <FormTextArea
                            value={data?.accompaniedMeetingsDiscussedNotes}
                            onBlur={(value) => patchVulnerabilitySection(data.vulnerabilitySectionId, "accompaniedMeetingsDiscussedNotes", value)} />}
                </Col>
            </Row>
            <Row className="align-items-center">
                <Col xs={auto} xxl={6}>
                    <FormLabel>
                        Are special steps needed to address vulnerabilities?
                    </FormLabel>
                </Col>
                <Col xs={auto} xxl={1}>
                    {isLoading
                        ? <Skeleton width={100} />
                        : <BooleanSelect
                            defaultValue={data.specialStepsRequired}
                            onBlur={({ value }) => patchVulnerabilitySection(data.vulnerabilitySectionId, "specialStepsRequired", value)} />}
                </Col>
            </Row><div className="row my-2">
                <RichTextEditor
                    className="mt-2"
                    label={"Provide a description of any special steps needed, or an explanation of why no steps are necessary"}
                    defaultValue={data?.specialStepsNotes?.notes}
                    isLoading={isLoading}
                    onBlur={(newValue) => patchNotesSection(data?.specialStepsNotes.notesId, newValue)} />
            </div>
        </>}
    </Container>
}

export default VulnerabilitiesSection